export const NAME = 'account';

export const LOCALSTORAGE_KEY_ACCOUNT_USER = 'user';

/**
 * Here goes the actionTypes
 */

export const UPDATE_ACCOUNT_USER = 'UPDATE_ACCOUNT_USER';
export const RESET_ACCOUNT_USER = 'RESET_ACCOUNT_USER';



// WEBPACK FOOTER //
// ./src/services/account/constants.js